interface GradientBarProps {
  color: string;
  lightenAmount?: number;
  className?: string;
}

const lightenColor = (hex: string, percent = 0.25) => {
  const cleanHex = hex.replace("#", "");

  const num = parseInt(cleanHex, 16);
  let r = (num >> 16) + Math.round(255 * percent);
  let g = ((num >> 8) & 0xff) + Math.round(255 * percent);
  let b = (num & 0xff) + Math.round(255 * percent);

  r = Math.min(255, r);
  g = Math.min(255, g);
  b = Math.min(255, b);

  return `rgb(${r}, ${g}, ${b})`;
};

const GradientBar = ({
  color,
  lightenAmount = 0.25,
  className = "",
}: GradientBarProps) => {
  const from = `${color}80`;
  const to = lightenColor(color, lightenAmount);

  return (
    <div
      className={`absolute bottom-0 left-0 right-0 h-1 opacity-0 group-hover:opacity-100 transition-opacity ${className}`}
      style={{
        background: `linear-gradient(to right, ${from}, ${to})`,
      }}
    />
  );
};

export default GradientBar;